export default __webpack_public_path__ + "static/media/patent2image1.7fed7689.jpeg";